import { makeAssistantToolUI } from '@assistant-ui/react'
import { useMemo } from 'react'
import { SearchUserGuideView } from '@/components/agent/tools/SearchUserGuideView'
import type { ToolRunStatus } from './parse-tool-result'
import {
  parseSearchResult,
  type SearchUserGuideArgs,
  type SearchUserGuideResult,
} from './user-guide'

interface RenderProps {
  args: SearchUserGuideArgs
  result?: SearchUserGuideResult | string
  status: ToolRunStatus
}

/** Connected `search_user_guide` card: parses the payload and renders the view. */
function SearchUserGuideRender({ args, result, status }: RenderProps) {
  const parsed = useMemo(() => parseSearchResult(result), [result])
  return (
    <SearchUserGuideView
      args={args}
      parsed={parsed}
      running={status.type === 'running'}
      errored={status.type === 'incomplete'}
    />
  )
}

export const SearchUserGuideToolUI = makeAssistantToolUI<
  SearchUserGuideArgs,
  SearchUserGuideResult | string
>({
  toolName: 'search_user_guide',
  render: SearchUserGuideRender,
})
